import React, { useEffect, useState } from 'react'
import CustomAutoComplete from '../../../../common/CustomAutoComplete'
import { updateObjectStateValue } from '../../../../utils/FunctionHelpers'
import { withSnackbar } from '../../../../utils/SnackbarHOC'
import { getAll } from '../../../Services/SocieteService'

const Step1 = ({ importData, errors, setImportData, snackbarShowMessage }) => {
    const [societeData, setSocieteData] = useState({
        isLoading: false,
        data: [],
        label: "SOCIETE",
        required: true
    })
    const [reloadSocietes, setReloadSocietes] = useState(false)

    const handleChange = (event) => {
        setImportData((prevState) => ({
            ...prevState,
            [event.target.name]: event.target.value
        }))
    }

    const handleSocietesChange = (societe) => {
        handleChange({
            target: {
                name: 'societe',
                value: societe
            }
        })
    }

    const loadSocietes = () => {
        updateObjectStateValue(
            setSocieteData,
            { isLoading: true, data: [] }
        )
        const params = `?firstChar=`
        getAll(params).then(({ data }) => {
            const updatedData = data.map(item => ({
                ...item,
                selectionName: item.nomSociete
              }));
            updateObjectStateValue(
                setSocieteData,
                { isLoading: false, data: updatedData }
            )
        }).catch(() => {
            snackbarShowMessage("Erreur de chargement des sélections.", "error", 4000)
        }).finally(() => {
            updateObjectStateValue(
                setSocieteData,
                { isLoading: false }
            )
        })
    }

    useEffect(() => {
        loadSocietes()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reloadSocietes])

    return (
        <>
            <CustomAutoComplete listData={societeData} errors={errors} value={importData.societe} handleDataChange={handleSocietesChange} name="societe" />
        </>
    )
}

export default withSnackbar(Step1)